/** HubSpot card iframes hosted under /external-apps/hubspot/ (JWT in URL path). */
export const isHubspotExternalAppPath = (pathname: string): boolean =>
  pathname.startsWith('/external-apps/hubspot/')
